export const promotedInformation = [{
  title: 'Access to Rooms',
  free: {
    check: true,
    text: 'Free rooms only'
  },
  premium: {
    check: true
  }
}, {
  title: 'Browser-Based Hacking (AttackBox)',
  free: {
    check: true,
    text: '1 hour a day'
  },
  premium: {
    check: true,
    text: 'Unlimited'
  }
}, {
  title: 'Full access to guided learning paths',
  free: {
    check: false
  },
  premium: {
    check: true
  }
}, {
  title: 'Certificate of Completion',
  free: {
    check: false
  },
  premium: {
    check: true
  }
}, {
  title: 'Access to real-world environments/networks',
  free: {
    check: false
  },
  premium: {
    check: true
  }
}] as const;